// extracted by mini-css-extract-plugin
module.exports = {"range":"range_range__1XGaW"};